import React from 'react'
import './CSS/ContactUs.css'

const ContactUs = () => {
  return (
    <div>
      Contact Us
    </div>
  )
}

export default ContactUs
